export default function Hero() {
  return (
    <section id="hero" className="relative pt-[72px] min-h-[600px] md:min-h-[700px] flex items-center bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/60 text-primary-700 text-xs font-semibold mb-6 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              娱乐圈 · 网红圈 · 综艺圈
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-4">
              黑料吃瓜网 · 最新娱乐爆料聚合平台
            </h1>
            <p className="text-base md:text-lg text-primary-500 font-heading mb-5">
              一区二区即点即播 · 不放过每一个瓜
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-6">
              黑料吃瓜网是国内领先的娱乐爆料资讯聚合平台，覆盖娱乐圈、网红圈、综艺圈、影视圈、音乐圈等热门领域。每天24小时不间断更新最新爆料内容，一区二区分区清晰，所有视频高清在线播放，无需下载即可畅享完整吃瓜体验。我们坚持独立、客观的内容原则，多重核验每一条爆料信息，为千万网友提供真实、快速、全面的娱乐资讯服务。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-xl lg:max-w-none mb-8">
              当前全站热点聚焦：某顶流艺人私生活大起底持续发酵、知名企业高管利益输送事件多方关注、网红主播虚假人设产业链曝光。更多精彩吃瓜内容每日更新中，关注黑料吃瓜网不错过每一个爆料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">15,000+</div>
                <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">8,000万+</div>
                <div className="text-xs text-foreground-500 mt-1">月均浏览</div>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-800 font-heading">24小时</div>
                <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即浏览热点爆料
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-full font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apps-line"></i>
                按分区浏览内容
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Breaking%20entertainment%20news%20collage%20concept%2C%20dramatic%20red%20and%20dark%20tones%2C%20celebrity%20gossip%20headlines%20floating%2C%20warm%20cinematic%20lighting%2C%20newspaper%20clippings%20and%20social%20media%20posts%20aesthetic%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20dynamic%20composition&width=1000&height=750&seq=hero-main&orientation=landscape"
                alt="黑料吃瓜网 - 最新娱乐爆料聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">实时更新</span>
                <span className="text-background-50 text-sm font-medium">每天数百条最新爆料</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}